import React, { useState } from 'react'
import styled from 'styled-components'

import { Spacer } from 'components/core/Spacer'

import { ModalDialog } from 'components/core/Dialog'
import { H2Responsive, P } from 'components/core/Typography'
import { DecimalInput } from 'components/core/Input'
import { PrimaryButton } from 'components/core/Buttons'
import { animated, SpringValue } from '@react-spring/web'
import { OverlayContainer } from '@react-aria/overlays'

const AnimatedOverlayContainer = animated(OverlayContainer)

type Styles = {
  opacity: SpringValue<number>
  y: SpringValue<number>
  scale: SpringValue<number>
}

type Props = {
  handleAddGooClick: () => void
  setIsModalOpen: (isOpen: boolean) => void
  setGooAmountToDepositInput: (amount: string) => void
  styles: Styles
  gooPhysicalBalance: string | undefined
  gooAmountToDepositInput: string
}

function DepositGooModal({
  styles,
  setGooAmountToDepositInput,
  setIsModalOpen,
  handleAddGooClick,
  gooPhysicalBalance,
  gooAmountToDepositInput,
}: Props) {
  const [modalState, setModalState] = useState<'init' | 'loading' | 'finished'>('init')

  const isLoading = modalState === 'loading'
  return (
    <AnimatedOverlayContainer
      style={{ position: 'relative', opacity: styles.opacity, zIndex: 10000 }}
      key={'deposit-goo'}
    >
      <ModalDialog
        shouldCloseOnBlur={false}
        allowScroll={false}
        hardBlur
        shouldCloseOnInteractOutside={(el) => true}
        isKeyboardDismissDisabled={false}
        containerStyles={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: 420,
          paddingLeft: 24,
          paddingRight: 24,

          margin: '0 10px',
          transform: styles.y.interpolate(
            (value) => `translate3d(0px, ${value ?? 0}px, 0px)`,
          ) as any,
          boxShadow: `0px 24px 60px rgba(0, 0, 0, 0.06), 0px 12px 20px rgba(0, 0, 0, 0.05), 0px 4px 8px rgba(0, 0, 0, 0.02)`,
          background: '#FFFFFF',
          border: '3px solid #080A0C',
          borderRadius: '40px',
        }}
        gooContainerStyles={{
          scale: styles.scale as any,
        }}
        isOpen
        showGooBackground
        onClose={() => setIsModalOpen(false)}
        isDismissable
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flex: 1,
            padding: 20,
          }}
        >
          <H2Responsive style={{ color: 'black' }}>Deposit Goo</H2Responsive>
          {modalState === 'finished' ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 220,
                color: 'black',
                textAlign: 'center',
                fontWeight: 600,
              }}
            >
              <P style={{ fontSize: 20, lineHeight: 1.5 }}>
                You{"'"}ve succesfully deposited {gooAmountToDepositInput} Goo into the factory
              </P>
            </div>
          ) : (
            <>
              <Spacer size={8} />
              <MaxGooBalanceContainer
                onClick={() => {
                  if (!gooPhysicalBalance) {
                    return
                  }
                  setGooAmountToDepositInput(gooPhysicalBalance)
                }}
                style={{ display: 'flex', flex: 1, justifyContent: 'flex-end', color: 'black' }}
              >
                <P style={{ fontWeight: 600, marginBottom: 8 }}>Max: {gooPhysicalBalance ?? 0}</P>
              </MaxGooBalanceContainer>
              <Spacer size={4} />
              <DecimalInput
                style={{ maxWidth: 320 }}
                value={gooAmountToDepositInput}
                onChange={setGooAmountToDepositInput}
              />
              <Spacer size={8} />
              <PrimaryButton
                isDisabled={isLoading}
                style={{ maxWidth: 320, marginTop: 16 }}
                onPress={async () => {
                  setModalState('loading')
                  await handleAddGooClick()
                  setModalState('finished')
                }}
              >
                {isLoading ? 'Loading' : 'Deposit'}
              </PrimaryButton>
            </>
          )}
        </div>
      </ModalDialog>
    </AnimatedOverlayContainer>
  )
}

const MaxGooBalanceContainer = styled.div`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

export default DepositGooModal
